import React from "react";
export const AcademyContext = React.createContext({});
